import { Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { themeOrange } from "../../../../utils/colorTheme";
import "./index.css";

export const ServicesCard = (props) => {
  const { src, heading, onClick, sub_heading } = props;

  return (
    <Stack onClick={onClick} className="card-container">
      <Stack alignItems={"center"} justifyContent={"center"} sx={{ flex: 1 }}>
        <img className="img-size" src={src} />
      </Stack>
      <Stack
        alignItems={"center"}
        color={"#000000"}
        className="card-text-wrapper"
      >
        <p className="card-heading-service">{heading}</p>
      </Stack>
    </Stack>
  );
};
